import { Box, Link, Image, Flex } from "@chakra-ui/react";
import React from 'react'

const Stats = () => {
  return (
    <Box  textAlign={"center"} w={"75%"} m={"auto"} >
      <h2 className="section__title">My Statistics</h2>
      <Box m="auto" mt={"5"}>
        <Link href="https://github.com/amareshcoding" isExternal>
          <Image
            m={"auto"}
            w={{ lg: "60%", md: "70%", sm: "90%" }}
            src="https://github-readme-streak-stats.herokuapp.com?user=amareshcoding"
            alt="Github Statistics"
          />
        </Link>
      </Box>
      <Flex w={"full"} m="auto" mt={"7"} justify={"space-around"} gap="2rem" flexDirection={{lg:"row",base:"column",sm:"column",md:"row"}}>
        {/* <Link href="https://github.com/amareshcoding" isExternal>
          <Image
            align="center"
            src="https://github-readme-stats.vercel.app/api/top-langs/?username=amareshcoding" //launguages
          />
        </Link> */}
        <Link href="https://github.com/amareshcoding" isExternal>
          <Image
            align="left"
            src="https://github-readme-stats.vercel.app/api?username=amareshcoding&count_private=true&show_icons=true" //stats
          />
        </Link>
      </Flex>
    </Box>
  );
}

export default Stats


